export const STATUS_TYPES = {
  0: {
    text: '未开始',
    color: 'success'
  },
  1: {
    text: '已开始',
    color: 'warning'
  },
  2: {
    text: '已结束',
    color: 'info'
  },
  3: {
    text: '奖励已发送',
    color: 'primary'
  },
  4: {
    text: '无人中奖，解冻余额',
    color: 'info'
  },
  5: {
    text: '无人参与',
    color: 'info'
  }
};

export const PROJECT_TYPES = [
  { label: '内部项目', value: 0 },
  { label: '外部项目', value: 1 }
];
